/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2022 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 * Copyright 2024 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { createAction, Dispatch } from '@reduxjs/toolkit';
import Api from 'Api/Api';
import { UserClient } from 'Api/generated';
import { Component } from 'react';

export const UserActionTypes = {
  Query: 'Users_Query',
  Queried: 'Users_Queried',
  Update: 'Users_Update',
  Updated: 'Users_Updated',
  Create: 'Users_Create',
  Created: 'Users_Created',
  Delete: 'Users_Delete',
  Deleted: 'Users_Deleted',
  SetAdminRole: 'User_SetAdminRole',
  SetMemberRole: 'User_SetMemberRole',
  SetSuperAdminRole: 'User_SetSuperAdminRole',
};

export const UserAction = {
  Query: createAction(UserActionTypes.Query),
  Queried: createAction<UserClient[]>(UserActionTypes.Queried),
  Update: createAction(UserActionTypes.Update),
  Updated: createAction<UserClient>(UserActionTypes.Updated),
  Create: createAction(UserActionTypes.Create),
  Created: createAction<UserClient>(UserActionTypes.Created),
  Delete: createAction<UserClient>(UserActionTypes.Delete),
  Deleted: createAction<UserClient>(UserActionTypes.Deleted),
  SetAdminRole: createAction<UserClient>(UserActionTypes.SetAdminRole),
  SetMemberRole: createAction<UserClient>(UserActionTypes.SetMemberRole),
  SetSuperAdminRole: createAction<UserClient>(UserActionTypes.SetSuperAdminRole),
};

export class UserActions extends Component {
  static QueryUsers() {
    return function (dispatch: Dispatch) {
      dispatch(UserAction.Query());
      Api.Users.getUsers().then((data) => dispatch(UserAction.Queried(data.data)));
    };
  }

  static CreateUser(User: UserClient) {
    return function (dispatch: Dispatch) {
      dispatch(UserAction.Create());
      Api.Users.postUser(User)
        .then(() => {
          dispatch(UserAction.Created(User));
        })
        .then(() => Api.Users.getUsers().then((data) => dispatch(UserAction.Queried(data.data))))
        .catch(() => {
          console.error('Could not CreateUser');
        });
    };
  }

  static UpdateUser(User: UserClient) {
    return function (dispatch: Dispatch) {
      dispatch(UserAction.Update());
      Api.Users.putUser(User.Id || '', User)
        .then(() => {
          dispatch(UserAction.Updated(User));
        })
        .then(() => console.log('test', User))
        .catch(() => {
          console.error('Could not UpdateUser');
        });
    };
  }

  static DeleteUser(User: UserClient) {
    return function (dispatch: Dispatch) {
      if (User.Id === undefined || User.Id == null) {
        console.error('Delete User without ID not possible.');
        return;
      } else {
        dispatch(UserAction.Delete(User));
        Api.Users.deleteUser(User.Id)
          .then(() => {
            dispatch(UserAction.Deleted(User));
          })
          .catch(() => {
            console.error('Could not DeleteUser');
          });
      }
    };
  }

  static SetAdminRole(User: UserClient) {
    return function (dispatch: Dispatch) {
      if (User.Id === undefined || User.Id == null) {
        console.error('Set AdminRoleUser without ID not possible.');
        return;
      } else {
        dispatch(UserAction.SetAdminRole(User));
        Api.Users.setAdminRole(User.Id)
          .then(() => {
            dispatch(UserAction.SetAdminRole(User));
          })
          .catch(() => {
            console.error('Could not SetAdminRole');
          });
      }
    };
  }

  static SetMemberRole(User: UserClient) {
    return function (dispatch: Dispatch) {
      if (User.Id === undefined || User.Id == null) {
        console.error('Set MemberRoleUser without ID not possible.');
        return;
      } else {
        dispatch(UserAction.SetMemberRole(User));
        Api.Users.setMemberRole(User.Id)
          .then(() => {
            dispatch(UserAction.SetMemberRole(User));
          })
          .catch(() => {
            console.error('Could not SetMemberRole');
          });
      }
    };
  }

  static SetSuperAdminRole(User: UserClient) {
    return function (dispatch: Dispatch) {
      if (User.Id === undefined || User.Id == null) {
        console.error('Set MemberRoleUser without ID not possible.');
        return;
      } else {
        dispatch(UserAction.SetSuperAdminRole(User));
        Api.Users.setSuperAdminRole(User.Id)
          .then(() => {
            dispatch(UserAction.SetSuperAdminRole(User));
          })
          .catch(() => {
            console.error('Could not SetSuperAdminRole');
          });
      }
    };
  }
}
